module.exports = __webpack_public_path__ + "static/media/recipe.59d332f8.jpg";